export default {
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://0s9g4f61kj.execute-api.us-west-2.amazonaws.com/dev"
  }
}


// WEBPACK FOOTER //
// ./src/aws-config.js